import { createFilterSlice } from './filterSlice';

const STORAGE_KEY = 'renewalReportFilters';
const defaultDebtorsFilters = {
	fromDate: null,
	toDate: null,
	ownerIds: [],
	branchIds: [],
};

export const renewalReportPrefsSlice = createFilterSlice({
	sliceName: 'renewalReportPrefs',
	storageKey: STORAGE_KEY,
	defaultFilters: defaultDebtorsFilters,
});

export const {
	setFromDate,
	setToDate,
	setOwnerIds,
	setBranchIds,
	resetFilters,
	pruneFilters,
} = renewalReportPrefsSlice.actions;

export default renewalReportPrefsSlice.reducer;
